import { PageHeader, tokens } from '@hotjar/hotsauce';
import { Page } from '@hotjar/webapp/components/Page';
import styled from '@emotion/styled';
import { ResponseLimitAlert } from '@hotjar/feedback';
import { useTranslation } from '@hotjar/translations';

export type FeedbackWizardMode = 'create' | 'edit';

export interface FeedbackWizardHeaderProps {
  mode: FeedbackWizardMode;
  name: string;
}

const MinHeightContainer = styled.div`
  min-height: ${tokens.spacer.x7};
  margin-bottom: ${tokens.spacer.x2};
`;

export function FeedbackWizardHeader({ mode, name }: FeedbackWizardHeaderProps): JSX.Element {
  const { t } = useTranslation('feedback');
  const titlesMap: Record<FeedbackWizardMode, string> = {
    create: t('feedback-wizard.header.empty-title'),
    edit: name,
  };

  return (
    <>
      <Page>
        <MinHeightContainer>
          <PageHeader title={titlesMap[mode]} />
        </MinHeightContainer>
      </Page>
      <ResponseLimitAlert location="feedback-wizard" featureGroup="feedback" />
    </>
  );
}
